import { css } from '@emotion/core';

export const iconButtonOverridesCSS = ({ colors }) => css`
    all: unset; // Reset default button CSS as this is completely custom
    display: flex;
    justify-content: space-around;
    align-items: center;
    cursor: pointer;
    border-radius: 2rem;
    color: ${colors.iconButtonDefault};
    height: 40px;
    width: 40px;

    &:hover,
    &:active {
        background-color: ${colors.lightSecondaryDefault};
    }

    > svg {
        &:hover,
        &:active,
        &:focus {
            color: ${colors.iconButtonDefault};
        }
    }

    &:focus {
        background-color: ${colors.lightSecondaryFocus};
    }
`;

export const iconButtonDisabledCSS = ({ colors }) => css`
    border: none;
    display: flex;
    cursor: not-allowed;
    justify-content: space-around;
    align-items: center;
    border-radius: 2rem;
    background-color: ${colors.white};
    color: ${colors.neutral70};
    height: 40px;
    width: 40px;
`;
